import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Logo } from "../../components/Logo";

/**
 * Trata o retorno do Emergent Google Auth.
 * URL recebida: /cliente/home#session_id=XXXX
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const { loginWithGoogleSession } = useAuth();
  const nav = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/cliente/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const u = await loginWithGoogleSession(sessionId);
        // limpa o hash
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Bem-vindo(a), ${u.name}`);
        nav("/cliente/home", { replace: true });
      } catch (err) {
        toast.error(err?.response?.data?.detail || "Não foi possível autenticar com Google");
        nav("/cliente/login", { replace: true });
      }
    })();
  }, [loginWithGoogleSession, nav]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
      <Logo size="md" />
      <Loader2 size={28} className="animate-spin mt-6 text-orange-500" />
      <p className="text-sm text-gray-500 mt-3">Validando seu acesso...</p>
    </div>
  );
}
